import React, { useEffect, useState } from "react";
import { ReactComponent as CloseIcon } from "../../../assets/icons/modal/close.svg";
import { ReactComponent as EditModalIcon } from "../../../assets/icons/modal/product.svg";
import { IOrder } from "../../../types/order.type";
import { IProduct } from "../../../types/product.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import EditOrderForm from "../forms/EditOrderForm/EditOrderForm";
import ViewOrderForm from "../forms/EditOrderForm/ViewOrderForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  isInfo: boolean;
  order: IOrder;
  products: IProduct[];
}

const EditOrderModal: React.FC<Props> = (props) => {
  const [isEdit, setIsEdit] = useState<boolean>(!props.isInfo);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  const onPressApply = async () => {
    props.onApply();
    props.onClose();
  };

  return (
    <DefaultModal>
      <div className={styles.container}>
        {isEdit ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Order"
              subTitle="Withdraw products to order"
            >
              <EditModalIcon />
            </ModalTitle>

            <EditOrderForm
              onClose={props.onClose}
              onApply={props.onApply}
              order={props.order}
              products={props.products}
            />
          </>
        ) : (
          <>
            <div className={styles.header}>
              <div className={styles.upSide}>
                <div />

                <button className={styles.upSideButton} onClick={props.onClose}>
                  <CloseIcon />
                </button>
              </div>
              <div className={styles.nameContainer}>
                <span className={styles.name}>
                  {props.order.client.fullName}
                </span>
                <span className={styles.email}>{props.order.client.phone}</span>
                <span className={styles.email}>{props.order.client.email}</span>
                <span className={styles.email}>
                  {props.order.client.adress}
                </span>
                <span className={styles.email}>{props.order.eircode}</span>
              </div>
            </div>
            <ViewOrderForm
              order={props.order}
              onClose={props.onClose}
              onPressEdit={() => setIsEdit(true)}
              onApply={props.onApply}
            />
          </>
        )}
      </div>
    </DefaultModal>
  );
};

export default EditOrderModal;
